import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { siQueryKeyFactory } from "app/pages/sales-intelligence/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useAccountAdminsQuery = () => {
    return useQuery<string[]>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: siQueryKeyFactory.accountAdmins(),
        placeholderData: keepPreviousData,
        queryFn({ signal }) {
            return salesApiService.contactAdmin.fetchAccountAdmins({ cancellation: signal });
        },
    });
};
